import PropTypes from 'prop-types';
import React from 'react';
import { Provider } from 'react-redux';
import { HistoryRouter  as  Router } from  'redux-first-history/rr6' ;
import { PersistGate } from 'redux-persist/integration/react';
import ReduxToastr from 'react-redux-toastr';
import LinearProgress from '@mui/material/LinearProgress';

import { Routing as Routes} from '../Routing';


export const RootProd = ({ store, history, persistor }) => (
  <Provider store={store}>
    <>
      <ReduxToastr
        timeOut={4000}
        newestOnTop={true}
        preventDuplicates
        position="top-left"
        transitionIn="fadeIn"
        transitionOut="fadeOut"
        progressBar
      />
      <PersistGate loading={<LinearProgress variant={'indeterminate'}/>} persistor={persistor}>
        <Router history={history}><Routes /></Router>
      </PersistGate>
    </>
  </Provider>
);

RootProd.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  persistor: PropTypes.object.isRequired

};
